<template>
    <v-container fill-height justify-center v-if="progress">
        <div class="text-center">
            <v-progress-circular
                :rotate="2"
                :size="100"
                :width="10"
                color="primary"
                indeterminate>
            </v-progress-circular>
        </div>
    </v-container>
    <v-container fluid fill-height v-else>
        <v-layout justify-center row pa-4 v-if="items.length > 0">
            <v-flex xs12 sm10 md6>
                <v-flex class="mb-3" text-center>
                    <h2>รายการพัสดุ</h2>
                </v-flex>
                <v-alert text="" type="info" class="v-alert-remark" v-show="otRemark != ''">{{ otRemark }}</v-alert>
                <v-alert text="" type="error" class="v-alert-remark" v-if="!isUseOTParcel">
                   ยังไม่มีการกำหนด เวลาที่ลูกค้าแจ้งขอรับพัสดุนอกเวลา หรือใส่เวลาผิด โปรดตรวจสอบ CMIS เมนูพัสดุ > ข้อมูลหลัก > กำหนดค่าเริ่มต้นระบบ                    
                </v-alert>  
                <v-expansion-panels class="my-4">
                    <v-expansion-panel>
                        <v-expansion-panel-header
                            style="border-left:solid 5px #fbc02d;background: #f3f4f6;font-size: 14px;color: #0045AF">
                            <v-flex justify="space-around" align="center">
                                <b><span>พัสดุรอรับ</span></b>
                            </v-flex>
                            <v-flex class="text-right">
                                <v-avatar left class="yellow darken-2" style="color: #ffffff">
                                    <b>{{ items.length }}</b>
                                </v-avatar>
                                <b><span class="ml-2" style="color: #000000">ชิ้น</span></b>
                            </v-flex>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content v-for="(item, index) in items">
                            <div class="mt-5">
                                <v-card class="mx-auto"
                                        @click="selectedParcel(items, index, item.SU_RUNNO)"
                                        v-if="(item.SU_STATUS === 'S' || item.SU_STATUS === 'W' || item.SU_STATUS === 'C') && (item.ST_REMARK !== 'กล่องใหญ่พิเศษ' || item.ST_REMARK === 'ห่อใหญ่พิเศษ')"
                                        style="border-left:solid 5px #fbc02d;background: #f3f4f6">
                                    <v-row>
                                        <v-col class="text-center my-auto" cols="3">
                                            <v-icon large color="yellow darken-2">
                                                mdi-package-variant-closed
                                            </v-icon>
                                            <br/>
                                            <span v-if="item.SU_STATUS === 'S'"
                                                  class="overline font-weight-bold"
                                                  style="color: #0045AF">
                                                รอรับ</span>
                                        </v-col>
                                        <v-col cols="7">
                                            <v-card-title> พัสดุคุณ {{ item.SU_FULLNAME }}</v-card-title>
                                            <v-card-text style="color: #ff2e34; font-size: 18px"> เลขที่อ้างอิง : {{ item.SU_CODE }}
                                            </v-card-text>
                                            <v-card-text> เลขที่ห้อง : {{ item.PD_ADDR }} ({{ item.PD_UNIT }})
                                            </v-card-text>
                                            <v-card-text> ประเภทพัสดุ : {{ item.ST_REMARK }}</v-card-text>
                                            <v-card-text> เลขที่พัสดุ : {{ item.SU_BARCODE }}</v-card-text>
                                            <v-card-text> วันที่รับ : {{ item.SU_RECIEVED_DATE }}</v-card-text>
                                        </v-col>
                                        <v-col cols="2" class="text-center my-auto">
                                            <v-icon v-if="item.CLICK == 1"
                                                    large
                                                    color="green darken-3">
                                                mdi-check-bold
                                            </v-icon>
                                        </v-col>
                                    </v-row>
                                </v-card>
                                <v-card class="mx-auto"
                                        v-if="item.SU_STATUS === 'I'"
                                        style="border-left:solid 5px #fbc02d;background: #f3f4f6">
                                    <v-row>
                                        <v-col class="text-center my-auto" cols="3">
                                            <v-icon large color="yellow darken-2">
                                                mdi-package-variant-closed
                                            </v-icon>
                                            <br/>
                                            <span class="overline font-weight-bold"
                                                  style="color: #0045AF">
                                                อยู่ในตู้
                                            </span>
                                        </v-col>
                                        <v-col cols="7">
                                            <v-card-title> พัสดุคุณ {{ item.SU_FULLNAME }}</v-card-title>
                                            <v-card-text style="color: #ff2e34; font-size: 18px"> เลขที่อ้างอิง : {{ item.SU_CODE }}
                                            </v-card-text>
                                            <v-card-text> เลขที่ห้อง : {{ item.PD_ADDR }} ({{ item.PD_UNIT }})
                                            </v-card-text>
                                            <v-card-text> ประเภทพัสดุ : {{ item.ST_REMARK }}</v-card-text>
                                            <v-card-text> เลขที่พัสดุ : {{ item.SU_BARCODE }}</v-card-text>
                                            <v-card-text> วันที่รับ : {{ item.SU_RECIEVED_DATE }}</v-card-text>
                                        </v-col>
                                    </v-row>
                                </v-card>
                                <v-card class="mx-auto"
                                        @click="selectedParcel(items, index, item.SU_RUNNO)"
                                        v-else-if="item.SU_STATUS === 'E' && (item.ST_REMARK !== 'กล่องใหญ่พิเศษ' || item.ST_REMARK === 'ห่อใหญ่พิเศษ')"
                                        style="border-left:solid 5px #F44336;background: #f3f4f6">
                                    <v-row>
                                        <v-col class="text-center my-auto" cols="3">
                                            <v-icon large color="red">
                                                mdi-package-variant-closed
                                            </v-icon>
                                            <br/>
                                            <span class="overline font-weight-bold"
                                                  style="color: #0045AF">
                                                เกินกำหนด
                                            </span>
                                        </v-col>
                                        <v-col cols="7">
                                            <v-card-title> พัสดุคุณ {{ item.SU_FULLNAME }}</v-card-title>
                                            <v-card-text style="color: #ff2e34; font-size: 18px"> เลขที่อ้างอิง : {{ item.SU_CODE }}
                                            </v-card-text>
                                            <v-card-text> เลขที่ห้อง : {{ item.PD_ADDR }} ({{ item.PD_UNIT }})
                                            </v-card-text>
                                            <v-card-text> ประเภทพัสดุ : {{ item.ST_REMARK }}</v-card-text>
                                            <v-card-text>เลขที่พัสดุ : {{ item.SU_BARCODE }}</v-card-text>
                                            <v-card-text>
                                                วันที่รับ : {{ item.SU_RECIEVED_DATE }}
                                            </v-card-text>
                                        </v-col>
                                        <v-col cols="2" class="text-center my-auto">
                                            <v-icon v-if="item.CLICK == 1"
                                                    large
                                                    color="green darken-3">
                                                mdi-check-bold
                                            </v-icon>
                                        </v-col>
                                    </v-row>
                                </v-card>
                                <v-card class="mx-auto my-2"
                                        @click="selectedParcel(items, index, item.SU_RUNNO)"
                                        v-else-if="item.ST_REMARK === 'กล่องใหญ่พิเศษ' || item.ST_REMARK === 'ห่อใหญ่พิเศษ'"
                                        style="border-left:solid 5px #F44336;background: #f3f4f6">
                                    <v-row>
                                        <v-col class="text-center my-auto" cols="3">
                                            <v-icon large color="red">
                                                mdi-package-variant-closed
                                            </v-icon>
                                            <br/>
                                            <span class="overline font-weight-bold"
                                                  style="color: #0045AF">
                                                ใส่ตู้ไม่ได้
                                            </span>
                                        </v-col>
                                        <v-col cols="7">
                                            <v-card-title> พัสดุคุณ {{ item.SU_FULLNAME }}</v-card-title>
                                            <v-card-text style="color: #ff2e34; font-size: 18px"> เลขที่อ้างอิง : {{ item.SU_CODE }}
                                            </v-card-text>
                                            <v-card-text> เลขที่ห้อง : {{ item.PD_ADDR }} ({{ item.PD_UNIT }})
                                            </v-card-text>
                                            <v-card-text> ประเภทพัสดุ : {{ item.ST_REMARK }}</v-card-text>
                                            <v-card-text>เลขที่พัสดุ : {{ item.SU_BARCODE }}</v-card-text>
                                            <v-card-text>
                                                วันที่รับ : {{ item.SU_RECIEVED_DATE }}
                                            </v-card-text>
                                        </v-col>
                                        <v-col cols="2" class="text-center my-auto">
                                            <v-icon v-if="item.CLICK == 1"
                                                    large
                                                    color="green darken-3">
                                                mdi-check-bold
                                            </v-icon>
                                        </v-col>
                                    </v-row>
                                </v-card>
                            </div>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                </v-expansion-panels>
                <div>
                    <v-btn color="#1565C0" block large dark @click="dialog2 = true">
                        ยืนยันแจ้งรับพัสดุนอกเวลา ({{ itemSelected.length }})
                    </v-btn>
                </div>
            </v-flex>
        </v-layout>
        <v-layout justify-center row pa-5 v-else>
            <v-flex class="mb-3" text-center>
                <h2>ไม่มีรายการพัสดุ</h2>
            </v-flex>
        </v-layout>
        <v-dialog v-model="dialog" max-width="290">
            <v-card>
                <v-card-title class="headline">ไม่มีรายการที่เลือก</v-card-title>
                <v-card-actions>
                    <div class="flex-grow-1"></div>
                    <v-btn color="green darken-1" text @click="dialog = false">
                        ตกลง
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="dialog2" max-width="290" persistent>
            <v-card>
                <v-card-title>เลือกวันที่รับ</v-card-title>
                <v-card-text>
                    <v-menu ref="menu"
                            v-model="menu"
                            :close-on-content-click="false"
                            :return-value.sync="date"
                            transition="scale-transition"
                            offset-y
                            min-width="290px">
                        <template v-slot:activator="{ on }">
                            <v-text-field v-model="date"
                                          prepend-icon="mdi-calendar"
                                          readonly
                                          v-on="on"></v-text-field>
                        </template>
                        <v-date-picker v-model="date"
                                       no-title
                                       scrollable
                                       :min="dateMin"
                                       :max="dateMax">
                            <div class="flex-grow-1"></div>
                            <v-btn text color="primary" @click="menu = false">Cancel</v-btn>
                            <v-btn text color="primary" @click="$refs.menu.save(date)">OK</v-btn>
                        </v-date-picker>
                    </v-menu>
                </v-card-text>
                <v-card-actions>
                    <div class="flex-grow-1"></div>
                    <v-btn color="green darken-1" text @click="dialog3 = true">
                        ตกลง
                    </v-btn>
                    <v-btn color="red darken-1" text @click="dialog2 = false">
                        ยกเลิก
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="dialog3" max-width="290" persistent>
            <v-card>
                <v-card-title>ยืนยันการรับพัสดุนอกเวลา</v-card-title>
                <v-card-actions>
                    <div class="flex-grow-1"></div>
                    <v-btn color="green darken-1" text @click="save()">
                        ตกลง
                    </v-btn>
                    <v-btn color="red darken-1" text @click="dialog3 = false">
                        ยกเลิก
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import EventBus from "@/EventBus";
import axios from "@/axios";

export default {
    data() {
        return {
            searchData: {
                searchText: this.getLocalItem().searchText,
                nt_runno: this.getLocalItem().nt_runno,
                type: "emp",
            },
            items: [],
            items2: [],
            itemSelected: [],
            itemSelectedShow: [],
            progress: true,
            dialog: false,
            dialog2: false,
            dialog3: false,
            date: new Date().toISOString().substr(0, 10),
            dateMin: new Date().toISOString().substr(0, 10),
            menu: false,    
            searchOTdetail: {
                ntRunno: this.getLocalItem().nt_runno,
                projectCode: '',
                type: "N"
            },        
            otRemark: "",
            otDateFinish: "",
            isUseOTParcel: false,
        };
    },
    computed: {
        dateMax() {
            let date = new Date();
            date.setDate(date.getDate() + 7);
            return date.toISOString().substr(0, 10);
        },
    },
    async mounted() {
        let localItem = this.getLocalItem();

        if (localItem.searchText) {
            window.scrollTo(0, 0);
            EventBus.$emit("set_navigation", {
                title: "พัสดุ",
                back_route: "ot-parcel-emp",
            });

            this.listParcel();
            // console.log(this.items)
        } else {
            this.$router.push({name: "ot-parcel"});
        }
        await this.getOTDetailParcel();
        console.log("this.isUseOTParcel=", this.isUseOTParcel);
    },
    methods: {
        goto(route_name, params) {
            if (route_name === "receive" && this.itemSelected.length === 0) {
                this.dialog = true;
            } else {
                let localItem = this.getLocalItem();
                localItem.itemSelected = this.itemSelected;
                localStorage.setItem("parcel", JSON.stringify(localItem));

                return this.$router.push({name: route_name});
            }
        },
        submit() {
            if (this.itemSelected.length === 0) {
                this.dialog = true;
            } else {
                this.dialog2 = true;
            }
        },
        save() {
            if (this.itemSelected.length === 0) {
                this.dialog3 = false;
                this.dialog2 = false;
                this.dialog = true;
            } else {
                this.dialog2 = false;
                this.saveOTParcel(this.itemSelected, this.date);
            }
        },
        async listParcel() {
            try {
                axios.post("/WaitParcelList", this.searchData).then((res) => {
                    console.log('ParcelList', res.data.data)
                    this.items = res.data.data;
                    // console.log('ParcelList', this.items)
                    let itemDefault = [];
                    let itemDefaultShow = [];
                    res.data.data.forEach(function (value) {
                        if (value.SU_STATUS === "S" || value.SU_STATUS === "E" || value.SU_STATUS === "W") {
                            // console.log('items', value.SU_RUNNO)
                            itemDefault.push(value.SU_RUNNO);
                            itemDefaultShow.push(value.SU_CODE);
                        }
                    });
                    this.itemSelected = itemDefault;
                    this.itemSelectedShow = itemDefaultShow;
                    // console.log('selectedParcel', this.itemSelected)

                    this.progress = false;
                });
            } catch (err) {
                console.log(err.message);
            }
        },
        async saveOTParcel(itemSelected, date) {
            try {
                let username = this.getLocalItem().user_id;
                itemSelected.forEach(function (su_runno) {
                    axios
                        .post("/SaveParcelOT", {
                            su_runno: su_runno,
                            dateOT: date,
                            username: username,
                        })
                        .then((res) => {
                            console.log("SaveParcelOT", res.data);
                        });
                    // console.log('SaveParcelOT', su_runno)
                });
                this.dialog3 = false;
                this.goto("ot-parcel-emp");
            } catch (err) {
                console.log(err.message);
            }
        },
        selectedParcel(array, index, data) {
            // console.log('selectedParcel',array,index,data)
            if (array[index].CLICK == "1") {
                array[index].CLICK = "0";
                this.removeItem(this.itemSelected, data);
                this.removeItem(this.itemSelectedShow, array[index].SU_CODE);
            } else {
                array[index].CLICK = "1";
                this.itemSelected.push(data);
                this.itemSelectedShow.push(array[index].SU_CODE);
            }
            // console.log('selectedParcel', this.itemSelected)
        },
        removeItem(array, item) {
            for (var i in array) {
                if (array[i] == item) {
                    array.splice(i, 1);
                    break;
                }
            }
        },
        async getOTDetailParcel() {
            try {
                console.log("OTDetailParcel=", this.searchOTdetail);
                await axios.post("/OTDetailParcel", this.searchOTdetail).then(res => {
                console.log("OTDetailParcel=", res.data.data);
                    if(res.data.data != null && res.data.data.length > 0){
                        this.otRemark = res.data.data[0]["EX_OT_REMARK"];
                        this.isUseOTParcel = this.validateTime(res.data.data[0]["EX_OT_FINISH"])
                        console.log("this.otRemark=", this.otRemark);
                        console.log("this.otDateFinish=", this.otDateFinish);
                    }
                });
            } catch (err) {
                console.log(err.message);
            }
        },
        validateTime(timeString){
            try {      
                const timeFormat = /^(2[0-3]|[01]?[0-9]):([0-5][0-9])$/; // รูปแบบ HH:MM
                // const dashOnly = /^-$/; // รูปแบบ - ตัวเดียว
                if (timeFormat.test(timeString) && (timeString.length === 5 && timeString.indexOf(":") > 0)) {
                    return true;
                } else {
                    return false;
                }
            }
            catch (err) {
                return false;
            }
        }
    },
};
</script>
<style scoped>
    .v-alert-remark {
        font-size: 16px;
        margin-bottom: 10px;
    }
</style>
